import React from 'react';
import { ToastType } from '@alefeducation/ui-elements-library-core';
import { injectAutoHideToastOfType } from '../../../utils/Toast';
import {
  SETTINGS_UPDATED_SUCCESS_MESSAGE,
  SOMETHING_WENT_WRONG_MESSAGE,
} from '../../../utils/constants';

const TOAST_SETTINGS_ID = 'toast-organisation-settings-page';
const ToastComponent = () => <div id={TOAST_SETTINGS_ID} />;

const error = () => {
  injectAutoHideToastOfType(
    TOAST_SETTINGS_ID,
    SOMETHING_WENT_WRONG_MESSAGE,
    ToastType.ERROR,
  );
};

const updateSettingsSuccess = () => {
  injectAutoHideToastOfType(
    TOAST_SETTINGS_ID,
    SETTINGS_UPDATED_SUCCESS_MESSAGE,
    ToastType.SUCCESS,
  );
};

const SettingsToastHelper = {
  TOAST_SETTINGS_ID,
  ToastComponent,
  error,
  updateSettingsSuccess,
};

export default SettingsToastHelper;
